import React from "react";

import { css, cx } from "@emotion/css";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { TextInput } from "@/uiKit/atoms/inputs/TextInput.tsx";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseSearchBarProps = {
  value: string;
  placeholder?: string;
  autoFocus?: boolean;
  onChange: (value: string) => void;
};

export type SearchBarProps = AtomProps<BaseSearchBarProps, StyleClasses<"root">>;

export const SearchBar: React.FC<SearchBarProps> = ({ id, value, onChange, className, classes, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <TextInput
      id={id}
      value={value}
      className={cx(styles.root, className)}
      onChange={value => onChange(value ?? "")}
      startAdornment={<Icons.search className={styles.icons} />}
      {...props}
    />
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({}),
  icons: css({
    width: FontSizes.body,
    height: FontSizes.body,
    margin: theme.spacing(0, 2, 0, 0),
    color: "inherit",
  }),
});
